
export function SectionDivRow({ children, className }: { children: React.ReactNode; className?: string} ) {
    return (
        <div className={`overflow-y-auto h-full pb-4 ${className}`}>
            {children}
        </div>
    )
}

